import {
  getStoredToken,
  isTokenExpired,
  handleUnauthorized
} from '../utils/authSession';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL 

export function getAuthToken() {
  return getStoredToken();
}

export async function apiFetch(path, { method = 'GET', body, headers = {}, auth = true } = {}) {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  if (auth) {
    const token = getAuthToken();
    if (token && isTokenExpired(token)) {
      handleUnauthorized();
      const error = new Error('Session expired. Please log in again.');
      error.status = 401;
      throw error;
    }
    if (token) finalHeaders.Authorization = `Bearer ${token}`;
  }
  
  try {
    const res = await fetch(`${API_BASE_URL}${path}`, {
      method,
      headers: finalHeaders,
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'omit'
    });
    
    // Check if response is OK
    if (!res.ok) {
      // Try to parse error response
      const contentType = res.headers.get('content-type') || '';
      let errorData = null;
      
      if (contentType.includes('application/json')) {
        try {
          errorData = await res.json();
        } catch (e) {
          // JSON parsing failed, use status text
        }
      }

      if (res.status === 401 && auth) {
        handleUnauthorized();
      }
      
      const error = new Error(errorData?.error || errorData?.message || `Request failed: ${res.status} ${res.statusText}`);
      error.status = res.status;
      error.data = errorData;
      throw error;
    }
    
    // Parse successful response
    const contentType = res.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    
    if (!isJson) {
      // Non-JSON response - return empty object with status
      console.warn(`Non-JSON response from ${path}, content-type: ${contentType}`);
      return {};
    }
    
    // Try to parse JSON
    try {
      const text = await res.text();
      if (!text || text.trim() === '') {
        // Empty response
        return {};
      }
      const data = JSON.parse(text);
      // Ensure we always return an object, not null
      return data || {};
    } catch (parseError) {
      console.error(`Failed to parse JSON response from ${path}:`, parseError);
      // Note: Can't read res.text() again here as it's already consumed
      return {};
    }
  } catch (error) {
    // Re-throw if it's already our custom error
    if (error.status) {
      throw error;
    }
    // Network or other errors
    console.error(`API fetch error for ${path}:`, error);
    throw new Error(error.message || 'Network error. Please check your connection.');
  }
}





